const B_1 = [
    {
        title: '招标公告审核',
        path: '/manage/business/auditzbgg/list'
    }
]

export default {
    path: 'auditzbgg',
    component: () => import(/*webpackChunkName: 'business-auditzbgg'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/manage/views/business/audit-zbgg/list'),
            meta: {
                title: '招标公告审核',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
